import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import th from "date-fns/locale/th";
import { subDays } from "date-fns";
import moment from "moment";
import "moment/locale/th";

interface HotSpotDatePickerProps {
  onSelectDate: (value: Date) => void;
  selectedDate: Date;
}
interface HotSpotDateRangePickerProp {
  onSelectDate: (startDate: Date, endDate: Date) => void;
  dateStart: Date;
  dateEnd: Date | null;
}
interface CalendarDatePickerProp {
  onSelectDate: (startDate: Date, endDate: Date | null) => void;
  onSelectDateType: (dateType: 1 | 2) => void;
  dateType: 1 | 2;
  start: Date;
  end: Date | null;
}
function CalendarDatePicker({
  onSelectDate,
  onSelectDateType,
  dateType,
  start,
  end,
}: CalendarDatePickerProp) {
  const [singleDate, setSingleDate] = useState<Date>(start);
  const [startDate, setStartDate] = useState<Date>(start);
  const [endDate, setEndDate] = useState<Date | null>(
    end !== null ? end : null
  );
  const [typeDateSelect, setTypeDateSelect] = useState<1 | 2>(dateType);

  const handleSelectTypeDate = (value: 1 | 2) => {
    setTypeDateSelect(value);
    setStartDate(new Date());
    setSingleDate(new Date());
    setEndDate(null);
    onSelectDateType(value);
    onSelectDate(new Date(), null);
  };
  const handleSelectSingleDate = (date: Date) => {
    setSingleDate(date);
    onSelectDate(date, null);
  };
  const handleSelectDateRange = (start: Date, end: Date) => {
    setStartDate(start);
    setEndDate(end);
    onSelectDate(start, end);
  };

  // useEffect(() => {
  //   if (start && end === null) {
  //     setSingleDate(new Date(start));
  //   }
  //   if (start && end) {
  //     setStartDate(new Date(start));
  //     setEndDate(new Date(end));
  //   }
  // }, [start, end]);

  // useEffect(() => {
  //   onSelectDate(startDate, endDate);
  // }, [dateType]);

  return (
    <>
      <div className="flex w-fit gap-1 px-2 py-[6px] shadow-z1 rounded-[40px] border-[1px] border-gray-1 bg-primary-contrast items-start">
        <button
          className={`rounded-[40px] max-w-[148px] px-[17px] py-[1px] text-xs ${
            typeDateSelect === 1
              ? "text-primary-main  bg-primary-light"
              : "text-text-primary"
          }`}
          onClick={() => handleSelectTypeDate(1)}
        >
          เลือกวัน
        </button>
        <button
          className={`rounded-[40px] max-w-[148px]  ${
            typeDateSelect === 2
              ? "text-primary-main  bg-primary-light"
              : "text-text-primary"
          } text-xs  px-[17px] py-[1px]`}
          onClick={() => handleSelectTypeDate(2)}
        >
          เลือกช่วงเวลา
        </button>
      </div>
      {typeDateSelect === 1 ? (
        <HotSpotDatePicker
          onSelectDate={(date: Date) => handleSelectSingleDate(date)}
          selectedDate={singleDate}
        />
      ) : (
        <HotSPotDateRagePicker
          dateStart={startDate}
          dateEnd={endDate}
          onSelectDate={(start: Date, end: Date) =>
            handleSelectDateRange(start, end)
          }
        />
      )}
    </>
  );
}
function HotSpotDatePicker({
  onSelectDate,
  selectedDate,
}: HotSpotDatePickerProps) {
  const [startDate, setStartDate] = useState(new Date());
  const handleChageDate = (date: Date) => {
    setStartDate(date);
    onSelectDate(date);
  };
  useEffect(() => {
    if (selectedDate) {
      setStartDate(selectedDate);
    } else {
      setStartDate(new Date());
    }
  }, [selectedDate]);

  return (
    <DatePicker
      renderCustomHeader={CustomHeader}
      selected={startDate}
      onChange={(date: Date) => handleChageDate(date)}
      startDate={startDate}
      minDate={subDays(new Date(), 30)}
      maxDate={new Date()}
      inline
      locale={th}
    />
  );
}
function HotSPotDateRagePicker({
  onSelectDate,
  dateStart,
  dateEnd,
}: HotSpotDateRangePickerProp) {
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(null);
  const onChange = (dates: any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    onSelectDate(start, end);
  };

  useEffect(() => {
    setStartDate(dateStart);
    setEndDate(dateEnd);
  }, [dateStart, dateEnd]);

  return (
    <DatePicker
      renderCustomHeader={CustomHeader}
      selected={startDate}
      startDate={startDate}
      endDate={endDate}
      minDate={subDays(new Date(), 30)}
      maxDate={new Date()}
      onChange={onChange}
      selectsRange
      inline
      locale={th}
    />
  );
}

const CustomHeader = ({ date, decreaseMonth, increaseMonth }: any) => {
  moment.locale("th");
  let datepickerMonth = new Date(date).getMonth();
  const formattedDate = moment(date).add(543, "years").format("MMMM YYYY");
  return (
    <div className="flex justify-between p-4">
      <p className="text-sm text-text-primary font-noto-sans-thai font-normal">
        {formattedDate}
      </p>
      <div className="flex gap-2">
        <button onClick={decreaseMonth} disabled={datepickerMonth <= 0}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_4860_12361)">
              <path
                d="M10.4304 3.57755C10.1145 3.25182 9.6043 3.25182 9.28843 3.57755L5.57089 7.41111C5.25502 7.73683 5.25502 8.26301 5.57089 8.58873L9.28843 12.4223C9.6043 12.748 10.1145 12.748 10.4304 12.4223C10.7463 12.0966 10.7463 11.5704 10.4304 11.2447L7.28792 7.99574L10.4304 4.75518C10.7382 4.42945 10.7382 3.89492 10.4304 3.57755Z"
                fill={datepickerMonth <= 0 ? "#E7E7E7" : "#8E8E8E"}
              />
            </g>
            <defs>
              <clipPath id="clip0_4860_12361">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <button onClick={increaseMonth} disabled={datepickerMonth >= 11}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_4860_12362)">
              <path
                d="M5.56958 3.57755C5.88545 3.25182 6.3957 3.25182 6.71157 3.57755L10.4291 7.41111C10.745 7.73683 10.745 8.26301 10.4291 8.58873L6.71157 12.4223C6.3957 12.748 5.88545 12.748 5.56958 12.4223C5.25371 12.0966 5.25371 11.5704 5.56958 11.2447L8.71208 7.99574L5.56958 4.75518C5.26181 4.42945 5.26181 3.89492 5.56958 3.57755Z"
                fill={datepickerMonth >= 11 ? "#E7E7E7" : "#8E8E8E"}
              />
            </g>
            <defs>
              <clipPath id="clip0_4860_12362">
                <rect
                  width="16"
                  height="16"
                  fill="white"
                  transform="matrix(-1 0 0 1 16 0)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default CalendarDatePicker;
